<template>
    <div :class="{ show: options, hide: !options }" class="l-mask">
        <div @click="closeTask" class="l-close-display"></div>
        <div :class="{ show: options, hide: !options }" class="l-display">
            <div class="l-section">
                <span class="l-week">战报上传</span>
                <span class="l-close"><i class="icon-lily icon-lily-guanbi1" @click="closeTask"></i></span>
            </div>

            <div class="l-level-list-section-box">
                <div class="l-level-item-box">
                    <div class="l-level-list-item" @click="handleToUpload(item)" v-for="(item, index) in list"
                        :key="index">
                        <div class="item-img">
                            <img :src="listName(item).url" alt="" />
                            <p>{{ listName(item).name }}</p>
                            <div class="l-read" v-if="item.battleStatus===3&&item.showRead === 0"></div>
                        </div>
                        <div class="item-title">
                            <p>{{ item.battleName }}</p>
                            <p>{{ item.startTime.slice(0, 10) }}至{{ item.endTime.slice(0, 10) }}</p>
                        </div>
                        <img  class="item-button" :src="listStatusUrl(item)" alt="" />
                    </div>
                </div>
            </div>
            <div class="l-footer">
                <div class="l-footer-title">
                    <span>*只展示最近6个月的战报情况</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TaskModel from './../../../models/task'
const taskModel = new TaskModel()
// import Lupload from "./../l-upload/l-task.vue"
export default {
    name: "l-task",
    props: {
        options: {
            type: Boolean,
        },
        list: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    components: {
    },
    computed: {
        listName() {
            return (data) => {
                let Object = {}
                let listData = this.dataType.filter(item => {
                    return data.battleType === item.code
                })
                if (listData.length > 0) {
                    Object = listData[0]
                } else {
                    Object = {
                        name: '----',
                        url: require('./images/record-yes.png')
                    }
                }
                return Object

            }
        },
        listStatusUrl() {
            return (data) => {
                let Object = {}
                let listData = this.dataStatus.filter(item => {
                    return data.battleStatus === item.code
                })
                if (listData.length > 0) {
                    Object = listData[0]
                } else {
                    Object = {
                        url: require('./images/upload-no.png')
                    }
                }
                return Object.url
            }
        }
    },
    watch: {},
    data() {
        return {
            dataType: [
                {
                    name: '划指视频',
                    code: 9,
                    url: require('./images/record-yes.png'),
                    type: 101,
                    uploadType: 'video'
                },
                {
                    name: '读音规则',
                    code: 8,
                    url: require('./images/pronunciation.png'),
                    type: 101,
                    uploadType: 'img'
                },
                {
                    name: '章抄写',
                    code: 10,
                    url: require('./images/copy.png'),
                    type: 101,
                    uploadType: 'img'
                },
                {
                    name: '修正文卷',
                    code: 11,
                    url: require('./images/amendment.png'),
                    type: 100,
                    uploadType: 'img'
                },

            ],
            dataStatus: [
                {
                    code: 1,
                    url: require('./images/upload-no.png')
                },
                {
                    code: 2,
                    url: require('./images/upload-ok.png')
                },
                {
                    code: 3,
                    url: require('./images/upload-remark.png')
                },
                {
                    code: 5,
                    url: require('./images/upload-pastdue.png')
                }
            ]
        };
    },
    mounted() { },
    methods: {
        closeTask() {
            this.$emit("closeTask");
        },
        hanldeToDetail() {
            this.$router.push({
                name: 'workDetail'
            })
        },
        handleToUpload(item) {
            if (item.battleStatus === 1||item.battleStatus === 2) {
                let data = this.dataType.filter(value => {
                    return item.battleType === value.code
                })[0]
                sessionStorage.setItem('wordUploadData', JSON.stringify({ ...data, ...item }))
                this.$router.push({
                    name: 'workUpload'
                })
            } else if (item.battleStatus === 3) {

                taskModel.postReportRead({
                    taskId: item.taskId,
                    id: item.id
                })
                sessionStorage.setItem('wordDetailData', JSON.stringify(item))
                this.$router.push({
                    name: 'workDetail'
                })
            }

        }
    },
};
</script>

<style lang="stylus" scoped>
@import "./l-task.styl";
</style>
